import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import moment from 'moment';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { DialogModule } from 'primeng/dialog';
import { TabViewModule } from 'primeng/tabview';
import { TagModule } from 'primeng/tag';
import { ToastModule } from 'primeng/toast';
import { Renewal } from '../../../../model/renewal/Renewal';
import { LoadingService } from '../../../../services/loading.service';

@Component({
  selector: 'app-renewal-review',
  standalone: true,
  imports: [
    CommonModule,
    CardModule,
    ButtonModule,
    TabViewModule,
    DialogModule,
    FormsModule,
    ToastModule,
    TagModule,
  ],
  providers: [MessageService],
  templateUrl: './renewal-review.component.html',
  styleUrl: './renewal-review.component.scss',
})
export class RenewalReviewComponent {
  activeIndex: number = 0;

  @Input()
  renewal!: Renewal;

  @Output()
  goToBackEvent: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private messageService: MessageService,
    private loadingService: LoadingService
  ) {}

  ngOnInit(): void {}

  calculateYearsOld(birthDay: string) {
    return moment().diff(birthDay, 'years');
  }

  getStatusSeverity(status: string): string {
    switch (status) {
      case 'accepted_payment_pending':
        return 'warning';
      case 'payment_started':
        return 'info';
      case 'finished_approved':
        return 'success';
      case 'finished_payment_error':
      case 'finished_error':
      case 'finished_payment_rejected':
        return 'danger';
      case 'payment_abandoned':
        return 'warning';
      default:
        return 'secondary';
    }
  }

  getStatusLabel(status: string): string {
    switch (status) {
      case 'accepted_payment_pending':
        return 'Pendiente de Pago';
      case 'payment_started':
        return 'Procesando Pago';
      case 'finished_approved':
        return 'Renovación Completada';
      case 'finished_payment_error':
        return 'Error en Pago';
      case 'finished_error':
        return 'Error en Renovación';
      case 'finished_payment_rejected':
        return 'Pago Rechazado';
      case 'payment_abandoned':
        return 'Pago Abandonado';
      default:
        return 'Estado Desconocido';
    }
  }

  getHumanTime(time: any) {
    return moment(time).format('DD/MM/yyyy hh:mm:ss a');
  }

  getRenewalAmount(): number {
    // Intentar obtener el monto del payment
    if (this.renewal.payment?.amount) {
      return this.renewal.payment.amount;
    }

    // Si no está en amount, intentar calcular desde paymentItems
    if (this.renewal.payment?.paymentItems && this.renewal.payment.paymentItems.length > 0) {
      return this.renewal.payment.paymentItems.reduce((sum, item) => sum + (item.valorTotal || 0), 0);
    }

    // Si no hay información de pago, retornar 0
    return 0;
  }

  goToBack() {
    this.goToBackEvent.emit(true);
  }
}
